import React from 'react';
import { useTranslation } from 'react-i18next';
import './ConfirmDialog.css';

const ConfirmDialog = ({ isOpen, onClose, onConfirm, title, message, confirmText, cancelText, type = 'danger' }) => {
  const { t } = useTranslation();
  
  // 如果没有传入文本，使用翻译的默认值
  const defaultTitle = title || t('confirmDialog.defaultTitle', '确认操作');
  const defaultMessage = message || t('confirmDialog.defaultMessage', '您确定要继续吗？');
  const defaultConfirmText = confirmText || t('confirmDialog.defaultConfirm', '确认');
  const defaultCancelText = cancelText || t('confirmDialog.cancel', '取消');
  
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  return (
    <div className="confirm-dialog-overlay" onClick={handleBackdropClick}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-dialog-header">
          {type === 'danger' && (
            <div className="confirm-dialog-icon confirm-dialog-icon-danger">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
            </div>
          )}
          {type === 'warning' && (
            <div className="confirm-dialog-icon confirm-dialog-icon-warning">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                <line x1="12" y1="9" x2="12" y2="13"></line>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </svg>
            </div>
          )}
          {type === 'info' && (
            <div className="confirm-dialog-icon confirm-dialog-icon-info">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="16" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12.01" y2="8"></line>
              </svg>
            </div>
          )}
          <h2 className="confirm-dialog-title">{defaultTitle}</h2>
        </div>
        
        <div className="confirm-dialog-body">
          <p className="confirm-dialog-message">{defaultMessage}</p>
        </div>

        <div className="confirm-dialog-footer">
          <button className="confirm-dialog-btn confirm-dialog-btn-cancel" onClick={onClose}>
            {defaultCancelText}
          </button>
          <button 
            className={`confirm-dialog-btn confirm-dialog-btn-confirm confirm-dialog-btn-${type}`} 
            onClick={handleConfirm}
          >
            {defaultConfirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;

